import { Switch, Redirect, Route, useRouteMatch } from 'peach/router'

import LoanDraw from './LoanDraw'
import LoanDraws from './LoanDraws'

const DrawRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <LoanDraws />
      </Route>
      <Route crumb path={`${path}/:drawId`}>
        <LoanDraw />
      </Route>
      <Redirect to={url} />
    </Switch>
  )
}

export default DrawRoutes
